var _path, _path2, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInfo = function SvgInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.99,
    d: "M11.05 15.586c-.074-.495-.018-1.513 0-1.723l.075-2.365c.014-.22-.114-.164-.201-.123-.427.204-.924.577-.924.577s.303-.819.595-1.16c.215-.302.678-.704 1.018-.736.401.009.606.07.573 1.07 0 0-.067 3.075-.01 3.611.059.17.62-.217.699-.279.079-.062.805-.717.805-.717s-.595 1.793-1.74 2.192c-.407.142-.83.073-.89-.347Z",
    fill: "var(--chakra-colors-green-400)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.925 8.75a.75.75 0 1 0 1.5 0 .75.75 0 0 0-1.5 0Z",
    fill: "var(--chakra-colors-green-400)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 14,
    height: 14,
    rx: 3,
    stroke: "var(--chakra-colors-green-400)"
  })));
};
export default SvgInfo;